import React from 'react';

import { NEStepsContext } from 'context/NEStepsContext';
import PropTypes from 'prop-types';

import { NEFormTestingBanner } from 'components/FormHelper/FormTestingBanners/NEFormTestingBanner';
import { NEStepsbar } from 'components/NEComponents/NEStepsbar/NEStepsbar';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

import './NEStepsContainer.sass';

export const NEStepsContainer = ({ children }) => (
  <NEStepsContext>
    <div className="ne-steps-container">
      <NEFormTestingBanner />
      <PageTitleSection title="Eintragung ins Installateur-Verzeichnis" notFramed />

      <NEStepsbar />
      {children}
    </div>
  </NEStepsContext>
);

NEStepsContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
